export default __webpack_public_path__ + "static/media/wafer-bg-bottom-flat.668c5f46.png";